import { useMutation } from "@tanstack/react-query";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { removeIntegrationAccount } from "@lib/integrationAccount";
import { invalidateAccountRelatedQueries } from "@api/account.api";
import { useScope } from "@state/scopeContext.lib";

export function useIntegrationAccountRemovalMutation(
    account: IntegrationAccount,
    onRemove?: () => void,
) {
    const { workspaceId } = useScope();

    return useMutation({
        mutationFn: () => removeIntegrationAccount(account),
        onSuccess: () => {
            invalidateAccountRelatedQueries({
                entityIds: account.financialAccount?.entityId
                    ? [account.financialAccount.entityId]
                    : undefined,
                workspaceId,
            });
            onRemove?.();
        },
    });
}
